import React, { useState } from 'react';
import api from '../../api/axiosConfig';

const normalizePhone = (phone) => {
  const digits = (phone || '').replace(/\D/g, '');
  if (digits.startsWith('0') && digits.length === 11) return digits;
  if (digits.length === 10) return '0' + digits;
  return phone;
};

const Driver_Login = ({ onLoginSuccess }) => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const normalizedPhone = normalizePhone(phone);
      
      const response = await api.post('/api/driver/login', {
        phone: normalizedPhone,
        password: password
      });

      const { access_token, driver_id, driver_name, user_id } = response.data;

      // LocalStorage'a kaydet
      localStorage.setItem('token', access_token);
      localStorage.setItem('role', 'driver');
      localStorage.setItem('user', JSON.stringify({
        id: user_id,
        name: driver_name,
        role: 'DRIVER',
        driver_id: driver_id
      }));
      localStorage.setItem('driver_id', driver_id.toString());

      // Login başarılı callback'i çağır
      if (onLoginSuccess) {
        onLoginSuccess({
          id: user_id,
          name: driver_name,
          role: 'DRIVER',
          driver_id: driver_id,
          token: access_token
        });
      }

    } catch (error) {
      console.error('Login error:', error);
      setError(
        error.response?.data?.detail || 
        error.response?.data?.message || 
        'Giriş yapılırken bir hata oluştu'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form 
        onSubmit={handleSubmit} 
        className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 w-full max-w-sm space-y-4"
      >
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-slate-800 mb-2">Şoför Girişi</h1>
          <p className="text-sm text-slate-600">BHT Transfer Sistemi</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
            {error}
          </div>
        )}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Telefon Numarası
          </label>
          <input 
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500" 
            placeholder="05xx xxx xx xx" 
            value={phone} 
            onChange={e => setPhone(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Şifre
          </label>
          <input 
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-blue-500 focus:border-blue-500" 
            placeholder="Şifrenizi giriniz" 
            type="password" 
            value={password} 
            onChange={e => setPassword(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <button 
          disabled={loading} 
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white py-2 px-4 rounded-lg font-medium transition-colors duration-200"
        >
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Giriş yapılıyor...
            </div>
          ) : (
            'Giriş Yap'
          )}
        </button>

        <div className="text-center pt-4">
          <p className="text-xs text-gray-500">
            Şifrenizi admin tarafından verilmiş şifre ile giriniz
          </p>
        </div>
      </form>
    </div>
  );
};

export default Driver_Login;
